import Swiper, { Lazy, Navigation, Pagination } from "swiper";

const Lightbox = {
  swiper: null,

  init() {
    this.events();
  },

  events() {
    // Single image.
    $("[data-lightbox]").on("click", (e) => {
      const toggle = $(e.currentTarget);
      const largeImg = toggle.data("lightbox");

      Lightbox.create([largeImg]);
    });

    //Single image second option.
    $(".image-lightbox").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const largeImg = btnEl.find("[data-lightbox]").data("lightbox");

      Lightbox.create([largeImg]);
    })

    // Photo gallery.
    $(".gallery-lightbox").on("click", (e) => {
      const btnEl = $(e.currentTarget);

      let images = btnEl.closest("[data-gallery]").data("gallery");
      images = images.split(",");

      let imageIndex = 0;
      imageIndex = btnEl.closest(".swiper")[0].swiper.realIndex;
      // console.log("This is activeImage: " + imageIndex);

      Lightbox.create(images, imageIndex);
    });

    // Video player
    $("[data-video]").on("click", (e) => {
      const toggle = $(e.currentTarget);
      const lightboxVideo = toggle.data("video");

      Lightbox.create([lightboxVideo], 0, "video");
    });

    $("body").on("click", ".lightbox__close", () => {
      Lightbox.close();
    });

    $("body").on("keyup", (e) => {
      if ("Escape" == e.key) {
        Lightbox.close();
      }
    });

    // Play video.
    $("body").on("click", "#playBtn", (e) => {
      const playBtn = $(e.currentTarget);
      const video = $(playBtn.parent().siblings("#heroVideo"));
      const stopBtn = $(playBtn.parent().siblings("#stopBtn"));

      // if (video.paused === true) {
      video.trigger("play");
      playBtn.toggleClass("hidden");
      stopBtn.toggleClass("hidden");
      // }
    });

    // Stop video on clikc.
    // $("body").on("click", "#heroVideo", (e) => {
    //   const video = $(e.currentTarget);

    //   if (video.paused !== true) {
    //     video.pause();
    //     playBtn.parentNode.classList.toggle("hidden");
    //     stopBtn.classList.toggle("hidden");
    //   }
    // });

    // Stop video on stop btn.
    $("body").on("click", "#stopBtn", (e) => {
      const stopBtn = $(e.currentTarget);
      const video = $(stopBtn.siblings("#heroVideo"));
      const playBtn = $(stopBtn.siblings().children("#playBtn"));

      video.trigger("pause");
      playBtn.toggleClass("hidden");
      stopBtn.toggleClass("hidden");
    });
  },

  close() {
    $("html").removeClass("no-scroll");
    $(".lightbox").removeClass("open");
    $(".video-lightbox").find("#heroVideo").trigger("pause");
    if (this.swiper) {
      this.swiper.destroy();
    }
  },

  create(objects, imageIndex = 2, type = "image") {
    let lightboxContainerHtml;
    let lightboxClass = type + "-lightbox";

    // If image lightbox.
    if ("image" == type) {
      let slidesHtml = "";
      objects.forEach((image) => {
        slidesHtml += `<div class="swiper-slide">
        <div class="lightbox__slide-image">
          <img src="${image}" alt="">
          </div>
        </div>`;
      });

      lightboxContainerHtml = `<div class="swiper lightbox-swiper">
        <div class="swiper-wrapper">
          ${slidesHtml}
        </div>
      </div>`;

    }
    // If video lightbox.
    if ("video" == type) {
      const lightboxVideo = objects[0];

      lightboxContainerHtml = `<div class="lightbox__video-container">
        <div class="lightbox__video-overlay">
          <button id="playBtn" class="btn btn-icon play-video-btn">
          </button>
        </div>

        <button id="stopBtn" class="stop-video-btn btn btn-icon btn-small hidden">
          <i class="isax isax-stop-circle"></i>
          stop
        </button>
        <video id="heroVideo" class="lightbox__video" width="960" src="${lightboxVideo}" alt=""
        poster="https://images.pexels.com/photos/6479567/pexels-photo-6479567.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
        >
      </div>`;
    }

    if (!$("#lightbox").length) {
      const lightboxHtml = `<div id="lightbox" class="lightbox ${lightboxClass}">
        <div class="lightbox__container">
          <div class="lightbox-container">
            ${lightboxContainerHtml}
          </div>

          <div class="lightbox__close close">
            <span class="first-span"></span>
            <span class="second-span"></span>
          </div>

          <button class="swiper-nav swiper-nav--next arrow-gallery btn-icon btn">
            <i class="isax isax-arrow-right-3"></i>
          </button>

          <button class="swiper-nav swiper-nav--prev arrow-gallery btn-icon btn">
            <i class="isax isax-arrow-left-2"></i>
          </button>

          <div class="lightbox__footer">
            <div class="lightbox__captions">
              <div class="lightbox__secondary-caption micro-tagline" style="opacity: 0; visibility: hidden">knitted summer dress</div>
              <div class="lightbox__primary-caption micro-tagline" style="opacity: 0; visibility: hidden">full length preview</div>
            </div>
            <div class="swiper-pagination micro-tagline">
            </div>
          </div>

        </div>
      </div>`;

      $(".wrapper").append(lightboxHtml);
    } else {
      $("#lightbox .lightbox-container").html(lightboxContainerHtml);
    }

    // If type is image render swiper
    if ("image" == type) {
      const lightboxEl = $("#lightbox");

      this.swiper = new Swiper(".lightbox-swiper", {
        watchSlidesProgress: true,
        modules: [Lazy, Pagination, Navigation],
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
        pagination: {
          el: lightboxEl.find(".swiper-pagination")[0],
          type: "fraction",
        },
        navigation: {
          prevEl: lightboxEl.find(".swiper-nav--prev")[0],
          nextEl: lightboxEl.find(".swiper-nav--next")[0],
        },
        initialSlide: imageIndex,
      });
    }

    $("html").addClass("no-scroll");
    $(".lightbox").addClass("open");
  },
};

export default Lightbox;
